import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import QuickLinks from './QuickLinks';
import { actions as uiActions } from 'ducks/ui';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
    operationMode: operationSelectors.operationMode(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinks);
